import { Box, Stack, styled } from '@mui/material'

export const TableWrapper = styled(Box)`
  padding: 0 13px;
`
export const Container = styled(Stack)`
  gap: 10px;
  height: 100%;
  width: 100%;
  background-color: #fff;
`
